import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const offBoardingListSlice = createSlice({
  name: "offBoardingList",

  initialState: { offBoardingList: [] },
  reducers: {
    setOffBoardingList: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.offBoardingList = payload;
    },
    resetOffBoardingList: (state) => {
      state.offBoardingList = [];
    },
  },
});

export const { setOffBoardingList, resetOffBoardingList } =
  offBoardingListSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default offBoardingListSlice.reducer;
